export default function IconQR() {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_15282_195791)">
        <path
          d="M15.3331 10.2027C14.9645 10.2027 14.6665 10.5013 14.6665 10.8693V14.0293C14.6665 14.3807 14.3805 14.6667 14.0298 14.6667H10.8698C10.5011 14.6667 10.2031 14.9653 10.2031 15.3333C10.2031 15.7013 10.5011 16 10.8698 16H14.0298C15.1165 16 15.9998 15.116 15.9998 14.0293V10.8693C15.9998 10.5013 15.7018 10.2027 15.3331 10.2027Z"
          fill="#247CB3"
        />
        <path
          d="M0.666667 10.2027C0.298 10.2027 0 10.5013 0 10.8693V14.0293C0 15.116 0.883333 16 1.97 16H5.13C5.49867 16 5.79667 15.7013 5.79667 15.3333C5.79667 14.9653 5.49867 14.6667 5.13 14.6667H1.97C1.61933 14.6667 1.33333 14.3807 1.33333 14.0293V10.8693C1.33333 10.5013 1.03533 10.2027 0.666667 10.2027Z"
          fill="#247CB3"
        />
        <path
          d="M14.0298 2.9709e-05H10.8698C10.5011 2.9709e-05 10.2031 0.298696 10.2031 0.666696C10.2031 1.0347 10.5011 1.33336 10.8698 1.33336H14.0298C14.3805 1.33336 14.6665 1.61936 14.6665 1.9707V5.1307C14.6665 5.4987 14.9645 5.79736 15.3331 5.79736C15.7018 5.79736 15.9998 5.4987 15.9998 5.1307V1.9707C15.9998 0.884029 15.1165 2.9709e-05 14.0298 2.9709e-05V2.9709e-05Z"
          fill="#247CB3"
        />
        <path
          d="M5.13 2.9709e-05H1.97C0.883334 2.9709e-05 0 0.884029 0 1.9707V5.1307C0 5.4987 0.298 5.79736 0.666667 5.79736C1.03533 5.79736 1.33333 5.4987 1.33333 5.1307V1.9707C1.33333 1.61936 1.61933 1.33336 1.97 1.33336H5.13C5.49867 1.33336 5.79667 1.0347 5.79667 0.666696C5.79667 0.298696 5.49867 2.9709e-05 5.13 2.9709e-05V2.9709e-05Z"
          fill="#247CB3"
        />
        <path
          d="M6.31834 8.5605H2.99967C2.63101 8.5605 2.33301 8.85917 2.33301 9.22717V12.9998C2.33301 13.3678 2.63101 13.6665 2.99967 13.6665H6.31834C6.68701 13.6665 6.98501 13.3678 6.98501 12.9998V9.22717C6.98501 8.85917 6.68634 8.5605 6.31834 8.5605ZM3.66634 9.89384H5.65167V12.3332H3.66634V9.89384Z"
          fill="#247CB3"
        />
        <path
          d="M13.0003 2.33333H9.83366C9.46499 2.33333 9.16699 2.632 9.16699 3V5.12133C9.16699 5.48933 9.46499 5.788 9.83366 5.788C10.2023 5.788 10.5003 5.48933 10.5003 5.12133V3.66667H12.3337V5.66667H11.5457C11.177 5.66667 10.879 5.96533 10.879 6.33333C10.879 6.70133 11.177 7 11.5457 7H13.0003C13.369 7 13.667 6.70133 13.667 6.33333V3C13.667 2.632 13.369 2.33333 13.0003 2.33333Z"
          fill="#247CB3"
        />
        <path
          d="M13.0004 9.60584H10.2731C9.90445 9.60584 9.60645 9.90451 9.60645 10.2725V12.9998C9.60645 13.3678 9.90445 13.6665 10.2731 13.6665H13.0004C13.3691 13.6665 13.6671 13.3678 13.6671 12.9998V10.2725C13.6671 9.90451 13.3691 9.60584 13.0004 9.60584ZM10.9398 10.9392H12.3338V12.3332H10.9398V10.9392Z"
          fill="#247CB3"
        />
        <path
          d="M8.31834 6.57588H2.99967C2.63101 6.57588 2.33301 6.87455 2.33301 7.24255C2.33301 7.61055 2.63101 7.90922 2.99967 7.90922H7.65167V12.3939C7.65167 12.7619 7.94967 13.0605 8.31834 13.0605C8.68701 13.0605 8.98501 12.7619 8.98501 12.3939V7.24255C8.98501 6.87455 8.68634 6.57588 8.31834 6.57588Z"
          fill="#247CB3"
        />
        <path
          d="M10.1667 6.74286C9.798 6.74286 9.5 7.04153 9.5 7.40953V8.3182C9.5 8.6862 9.798 8.98486 10.1667 8.98486H13.1667C13.5353 8.98486 13.8333 8.6862 13.8333 8.3182C13.8333 7.9502 13.5353 7.65153 13.1667 7.65153H10.8333V7.40953C10.8333 7.04153 10.5353 6.74286 10.1667 6.74286Z"
          fill="#247CB3"
        />
        <path
          d="M8.01432 3.19936C7.64566 3.19936 7.34766 3.49803 7.34766 3.86603V5.3807C7.34766 5.7487 7.64566 6.04736 8.01432 6.04736C8.38299 6.04736 8.68099 5.7487 8.68099 5.3807V3.86603C8.68099 3.49803 8.38299 3.19936 8.01432 3.19936Z"
          fill="#247CB3"
        />
        <path
          d="M6.16634 2.33349H2.99967C2.63101 2.33349 2.33301 2.63215 2.33301 3.00015V5.42415C2.33301 5.79215 2.63101 6.09082 2.99967 6.09082H6.16634C6.53501 6.09082 6.83301 5.79215 6.83301 5.42415V3.00015C6.83301 2.63215 6.53501 2.33349 6.16634 2.33349ZM3.66634 3.66682H5.49968V4.75749H3.66634V3.66682Z"
          fill="#247CB3"
        />
      </g>
      <defs>
        <clipPath id="clip0_15282_195791">
          <rect
            width={16}
            height={16}
            fill="white"
            transform="matrix(1 0 0 -1 0 16)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}